import { MapConfig } from "../components/Map/types";

interface MapData {
  maps: MapConfig[];
  title: string;
  selected: MapConfig;
  updateTime: string;
}

const configs: MapData = {
  maps: ["water"],
  title: "Live Water Pollutant Map",
  selected: "water",
  updateTime: "Updated on the 1st of every month",
};

export const mapConfig = configs;
